<template>
  <div class="calico-business-info">
    <div
      v-if="showBack"
      style="width: fit-content"
    >
      <button
        class="button-tertiary--small"
        @click="$emit('back')"
      >
        <i class="bi bi-arrow-left" />
        Back
      </button>
    </div>
    <div class="image-holder">
      <img
        v-if="info.photo"
        :src="info.photo"
        style="border-radius: 10px"
        width="100%"
      >
      <i
        v-else
        class="bi bi-shop placeholder-icon"
      />
    </div>
    <div class="content body--small">
      <span class="body--large">{{ info.name }}</span>
      <span v-if="info.addressLine1">{{ info.addressLine1 }}</span>
      <span v-if="info.addressLine2">{{ info.addressLine2 }}</span>
      <span v-if="info.category">{{ info.category }}</span>
      <div
        v-if="info.website"
        style="width: fit-content;"
      >
        <button
          class="button-link"
          @click="window.open(`${info.website}`)"
        >
          {{ (info.website || '').replace(/^https?:\/\//, '').replace(/\/$/, '') }}
        </button>
      </div>  
      <div
        v-if="info.phone"
        style="width: fit-content;"
      >
        <button
          v-if="info.phone"
          class="button-link"
        >
          {{ info.phone }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "CalicoBusinessInfo",
  props: {
    info: {
        type: Object,
        required: true,
        validator: (value) => {
          return value && value.id && value.name
        }
    },
    showBack: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      window,
    }
  }
};
</script>

<style lang="scss">
.calico-business-info {
  padding: $space-small 0;
  @include stack-space($space-small);
  color: $color-text-primary;

  .image-holder {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $color-neutral;
    border-radius: $radius-medium;
    overflow: hidden;
    width: 250px;
    height: 100px;

    .placeholder-icon {
      font-size: $icon-large;
      color: $color-white;
    }
  }

  .content {
    @include stack-space($space-none);

    .body--large {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .button-link {
      color: $color-lapis;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>